import Vue from 'vue'
import Vuex from 'vuex'
import snackbar from '@/store/snackbar'
import VuexORM from '@vuex-orm/core'
import database from './database'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    snackbar
  },
  plugins: [VuexORM.install(database)],
  state: {
    loading: false,
    fullLoading: false,
    bucketUrl: null,
    useBadges: false,
    lessonTerm: '',
    useCustom: false
  },
  mutations: {}
})
